/**
 * Presentation Layer - MedicalReservationsUploadPage
 * 診療予約CSVアップロードページコンポーネント
 *
 * ページのエントリーポイント。タイトル表示とコンテナの組み込みを行う。
 */

import React from 'react';
import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ja } from 'date-fns/locale';

import { MedicalReservationsUploadContainer } from './container';
import '../../../pages/ManagementList.css';

/**
 * 診療予約CSVアップロードページ
 *
 * @description
 * 診療予約CSVアップロード画面のエントリーポイント。
 * LocalizationProviderでラップしてコンテナをレンダリングする。
 *
 * @returns {React.ReactElement} ページコンポーネント
 *
 * @example
 * // App.tsx でのルーティング設定
 * <Route path="/appointments/upload" element={<MedicalReservationsUploadPage />} />
 */
const MedicalReservationsUploadPage: React.FC = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <Box className="management-page" sx={{ p: 0, minWidth: 0, maxWidth: 'none' }}>
        <div className="management-heading"><div><h1>診療予約CSVアップロード</h1><p>診療予約データをCSVファイルから登録します</p></div></div>

        {/* メインコンテンツ */}
        <MedicalReservationsUploadContainer />
      </Box>
    </LocalizationProvider>
  );
};

export { MedicalReservationsUploadPage };
